import { render } from "./OptionReplacePopUpPreview.vue?vue&type=template&id=12df69e6"
import script from "./OptionReplacePopUpPreview.vue?vue&type=script&lang=js"
export * from "./OptionReplacePopUpPreview.vue?vue&type=script&lang=js"

import "./OptionReplacePopUpPreview.vue?vue&type=style&index=0&id=12df69e6&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__